var Node = require('../hierarchy/frResultNode'),
    ShapeUtils = require('../../../../canvas/models/shapeUtils');


var NUM_WORDS_TO_INCLUDE_FROM_HIT_IN_PREVIEW = 5; // word is doing 6


module.exports = Node.extend({

    defaults: function() {

        var base = _.result( Node.prototype,  'defaults' );

        return _.extend( {}, base, {

            nodeType: 'HIT',

            id: null, // s/b unique id of the hit -- 'S_' + search searchModelId + _ + pageNoteId + _ need the number of the hit for that; now just an index

            search: null, // started storing a reference now ....
            searchModelId: null,
            words: [], // the word models -- now always one but leave array for later -- there could be > 1 per hit

            // populate from the word model -- actually this could but multi if they span ??? -- how would you handle?
            pageNumber: null,
            pageId: null,
            words: [],
            /* ---- 'ui/' -----*/

            pageNoteId: null,  // currently a link back to the parent note ... these should always be cid since they aren't saved
            shape: null, // only one per hit!

            // TODO: with only one shape may want to listen/put on the shape
            isMouseOverCanvasShape: false, // true if mouse is over any of the shapes of the hit on the canvas; triggers event to highlight hitView

            textPreviewTemplateContext: null // No need to derive each time in the view
        });

    },


    // TODO: move out of model logic but get going ... have a central hit toggled when this is then called at the end ...
    // Could cause memory leak
    // Hit to shape
    // Also could do more top down
    initialize: function() {

        this.listenTo( this, 'change:isApplied', this.toggleAppliedEventCallback );

    },

    // may not longer need since the hits can have only one shape
    toggleAppliedEventCallback: function() {

        var shape = this.get('shape');

        // Still necessary?
        if (!shape)
            return;

        var isApplied = this.get('isApplied');

        shape.uiModel.set( 'isHitApplied', isApplied );

    },

    /**
     * Return the coordinates of all the words to use for the shape.
     * Note: now in 1/10 mm
     */
    getDerivedShapeCoordinates: function() {

        var allWordPts = _.reduce( this.get('words'), function( memo, word ) {
            return memo.concat( word.get('boxFDDZoneUnitsDerived').getBoxCoordinates() );
        }, [] );

        // Utilize getPtsInRectOrder fn to get the size of a rect that would cover the whole thing
        return ShapeUtils.getPtsInRectOrder( allWordPts );

    },

    setIsMouseOverRowView: function( isOver ) {
        this.get('shape').uiModel.set('isMouseOverFindAndRedactHitView', isOver );
    },

    /**
     * Note not printing white space but utilizing css pseudo after ' ' --
     * helps not to have an underline on spaces, just the words.
     * ( Though then can't search in browser for spaces -- so may want to change ).
     * We could revisit in an attempt to make more performant / want more control.
     * Note in the future may be dependant on search type ... (this assumes words are next to each other )
     * Always print derived words -- expect when they span pages -- only stick to the one page ( shape can't go across) -- if
     * a derived word spans pages, we need to go back to the originals.
     * Perhaps could make better using logic with lines ( and derived lines );
     */
    setPreviewTextTemplateContext: function( documentDerivedWordModels ) {

        // HitWords are derived unless the were split on different page -- in which case broken into their original wds that compose them
        var hitWords = this.get('words'),
            hitPageId = this.get('pageId');

        // In the words to print -- remove any that are 'subwords' and not on the same page, with the parent derived models
        // ( with which they were originally replaced ).
        // So we are only printing from the derived array
        // Appears to work but then we show text than span onto the other page --
        // Normalize so working with the derived words array ( so all are derived )
        var derivedWordModelsOfHit = [],
            originalMultiPageSubWords = {}; // would have to be of this page id -- id X word

        hitWords.forEach( function(word) {

            var derivedParentId = word.get('derivedParentId');

            if ( derivedParentId ) {

                // could also put isParentBrokenByPage on the word model instead of getting here to make more efficient
                var derivedParentWord = _.find( documentDerivedWordModels, function(m) {
                    return m.get('id') === derivedParentId;
                });

                if ( derivedParentWord.get('isMultiPage') ) {

                    derivedWordModelsOfHit.push( derivedParentWord );
                    originalMultiPageSubWords[word.get('id')] = word; // store for later for replacing in text to print

                } else {

                    derivedWordModelsOfHit.push( word );
                }

            } else {

                derivedWordModelsOfHit.push( word );
            }

        });


        var firstWordId = derivedWordModelsOfHit[0].id;
        var lastWordId = derivedWordModelsOfHit[derivedWordModelsOfHit.length -1].id;

        // Currently these should be next to each other ( the only search type we have )
        // ( Assumes they are in order )
        // Could make a fn on the derivedWordModels obj
        var wdsToInclude =
            documentDerivedWordModels.slice(
                Math.max( firstWordId - NUM_WORDS_TO_INCLUDE_FROM_HIT_IN_PREVIEW, 0), // don't let it be negative
                lastWordId + NUM_WORDS_TO_INCLUDE_FROM_HIT_IN_PREVIEW + 1
            );

        // Purge anything not on the page of the hit ( prob not most efficient )
        // They are broken up so it's weird having text on one page from another ... (you'll see in next hit)
        var pageFilteredWdsToInclude = [];

        wdsToInclude.forEach( function( word ) {

            if ( !word.get('isMultiPage') && word.get('pageId') === hitPageId ) {
                pageFilteredWdsToInclude.push( word );

            } else {

                _.each( word.get('subWordReferences'), function( subwordReference ) {
                    // Only push the ones already on the page --
                    // avoids having to pull back in the original models array ...
                    if ( originalMultiPageSubWords[subwordReference.originalId] ) {
                        pageFilteredWdsToInclude.push(  originalMultiPageSubWords[subwordReference.originalId] );
                    }

                });
            }

        });


        // --- Creation of the template context ...
        var wordsToPrint = pageFilteredWdsToInclude.map( function(m) {
            return {
                word: m.get('wd')
            };
        });

        // Combo / Squash all of the hit words into one to print as a 'link'
        // -- maybe better way to do to also keep the word ids associated, but now not needed
        // With this we lose the association
        // ( Add spaces here -- they must be from the search )
        // Use hit words(!) -- not the derived ... so it can be original or derived
        var squashHitWord = {
            isHit: true,
            word: _.reduce( hitWords, function( squashedWordText, wordToPrint, i ) {
                return squashedWordText + wordToPrint.get('wd') + ( i < hitWords.length - 1 ? ' ' : '' );
            }, '')
        };

        // replace the squashed hit word text at the index of the original
        // ( non derived words -- since they were replaced in the prior the filter )
        wordsToPrint.splice(
            pageFilteredWdsToInclude.indexOf( hitWords[0] ), // use original hit words in case any were 'replaced'
            hitWords.length,
            squashHitWord
        );


        this.set( 'textPreviewTemplateContext', {
            words: wordsToPrint  // or just words to print
        } );


    },


    destroy: function() {

        this.stopListening();

        Node.prototype.destroy.apply( this, arguments );

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/hit/hit.js
 ** module id = 660
 ** module chunks = 0
 **/